import { Component, Input, OnInit } from '@angular/core';

import { Timeplan } from './timeplans/timeplan';
import { TimeplansService } from './timeplans/timeplans.service';
import { Incentive } from './incentives/incentive';
import { IncentivesService } from './incentives/incentives.service';
import { Team } from './teams/team';
import { TeamsService } from './teams/teams.service';

@Component({
  selector: 'app-strategy-overview',
  templateUrl: './strategy-overview.component.html',
  styleUrls: ['./strategy-overview.component.css']
})
export class StrategyOverviewComponent implements OnInit {

  @Input() onShowPeriod;

  section: String = 'timetable';

  addPeriod: Boolean = false;

  newTimeplan: Timeplan = {
    period: '',
    category: 'incremental',
    objective: ['']
  };

  mockTimeplans: Timeplan [] = [];

  addIncentive: Boolean = false;

  newIncentive: Incentive = {
    incentive: '',
    category: 'incremental',
    description: ''
  };

  mockIncentives: Incentive [] = [];

  addTeam: Boolean = false;

  newTeam: Team = {
    name: '',
    category: 'incremental',
    description: '',
    member: ['']
  };

  mockTeams: Team [] = [];

  constructor(
    private _timeplansService: TimeplansService,
    private _incentivesService: IncentivesService,
    private _teamsService: TeamsService
  ) {}

  getMockTimeplans(): void {
    this._timeplansService.getMockTimeplans().then(mockTimeplans => this.mockTimeplans = mockTimeplans);
  }

  getMockIncentives(): void {
    this._incentivesService.getMockIncentives().then(mockIncentives => this.mockIncentives = mockIncentives);
  }

  getMockTeams(): void {
    this._teamsService.getMockTeams().then(mockTeams => this.mockTeams = mockTeams);
  }

  ngOnInit(): void {
    this.getMockTimeplans();
    this.getMockIncentives();
    this.getMockTeams();
  }

  createTimeTable($event: any) {
    this.mockTimeplans.push(this.newTimeplan);
    this.newTimeplan = {
      period: '',
      category: 'incremental',
      objective: ['']
    };
    this.addPeriod = false;
  }

  deletePeriod(data: Timeplan) {
    const index: number = this.mockTimeplans.indexOf(data);
    if (index !== -1) {
        this.mockTimeplans.splice(index, 1);
    }
  }

  addObjective(data, event) {
    if (event.keyCode === 13) {
      data.objective.push(data.newObjective);
      data.showAddObjective = false;
      data.newObjective = '';
    }
  }

  createIncentivesTable($event: any) {
    this.mockIncentives.push(this.newIncentive);
    this.newIncentive = {
      incentive: '',
      category: 'incremental',
      description: ''
    };
    this.addIncentive = false;
  }

  deleteIncentive(data: Incentive) {
    const index: number = this.mockIncentives.indexOf(data);
    if (index !== -1) {
        this.mockIncentives.splice(index, 1);
    }
  }

  editDescription(data, event) {
    if (event.keyCode === 13) {
      data.showEditDescription = false;
    }
  }

  createTeamTable($event: any) {
    this.mockTeams.push(this.newTeam);
    this.newTeam = {
      name: '',
      category: 'incremental',
      description: '',
      member: ['']
    };
    this.addTeam = false;
  }

  deleteTeam(data: Team) {
    const index: number = this.mockTeams.indexOf(data);
    if (index !== -1) {
        this.mockTeams.splice(index, 1);
    }
  }

  addMember(data, event) {
    if (event.keyCode === 13) {
      data.member.push(data.newMember);
      data.showAddMember = false;
      data.newMember = '';
    }
  }

}



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/kanban/components/strategy-overview/strategy-overview.component.ts